import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";
import { useDownload } from "@/lib/downloads";

export const Footer = () => {
  const { primary } = useDownload();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-pg bg-[var(--pg-bg)] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <img
            src="/poly-grid-logo.png"
            alt="Poly Grid"
            className="h-12 w-auto"
            data-testid="footer-logo-image"
          />
          <p className="mt-4 text-sm text-[var(--pg-text-dim)] leading-relaxed max-w-xs">
            A multi-terminal grid system for developers who run more than one
            thing at a time.
          </p>
        </div>

        <div>
          <div className="tag-label text-[var(--pg-text-muted)] mb-3">
            Product
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/"
                data-testid="footer-link-features"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Features
              </Link>
            </li>
            <li>
              <a
                href="/#pricing"
                data-testid="footer-link-pricing"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Pricing
              </a>
            </li>
            <li>
              <a
                href={primary.url}
                download={!primary.external}
                target={primary.external ? "_blank" : undefined}
                rel={primary.external ? "noopener noreferrer" : undefined}
                data-testid="footer-link-download"
                onClick={() =>
                  trackEvent("download_app", {
                    location: "footer",
                    tier: "free",
                    platform: primary.platform,
                  })
                }
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Download
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="tag-label text-[var(--pg-text-muted)] mb-3">
            Resources
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/docs"
                data-testid="footer-link-docs"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Documentation
              </Link>
            </li>
            <li>
              <Link
                to="/docs/mcp-server"
                data-testid="footer-link-mcp"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                MCP Server
              </Link>
            </li>
            <li>
              <Link
                to="/docs/trial-licensing"
                data-testid="footer-link-licensing"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Trial &amp; Licensing
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="tag-label text-[var(--pg-text-muted)] mb-3">
            Legal
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/privacy"
                data-testid="footer-link-privacy"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Privacy
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                data-testid="footer-link-terms"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Terms
              </Link>
            </li>
            <li>
              <a
                href="mailto:support@poly-grid.com"
                data-testid="footer-link-contact"
                className="text-[var(--pg-text-dim)] hover:text-white"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-pg">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[var(--pg-text-muted)] font-mono">
          <div>
            © {new Date().getFullYear()} Poly Grid. Built for the terminal.
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 bg-green-accent rounded-full" />
            <span>all systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
